import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";

const FarmerCropCutForm = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      overflow: "hidden",
      width: "140px",
      height: "20p",
      margin: "3px",
    }),
    dropdownContainer: (base, state) => ({
      ...base,
      gridTemplateRows: "0 min-content",
    }),
  };
  const frmRef = useRef({});
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [unitsData, setUnitsData] = useState();
  const [itemSubType, setItemSubType] = useState();
  const [products, setProducts] = useState();

  const [selectedSubType, setSelectedSubType] = useState();
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectionSubType, setSelectionSubType] = useState([]);
  const [selectionProduct, setSelectionProduct] = useState([]);
  const [selectionUnit, setSelectionUnit] = useState([]);
  const [filterProducts, setFilterProducts] = useState();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [cropId, setCropId] = useState([]);
  

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const productRef = useRef({});

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "500px",
      overflow: "auto",
    },
  };
 
       
  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    //console.log(uniqueID);
    return uniqueID.toString();
  }

  const { sendRequest: postProductRequest } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      cropCutDate: moment(frmRef.current.cropCutDate.value).format(
        "DD/MM/YYYY"
      ),
      actualFieldSizeBeforeHarvest: frmRef.current.actualFieldSizeBeforeHarvest.value,
      cropCutWeightA: frmRef.current.cropCutWeightA.value,
      cropCutWeightB: frmRef.current.cropCutWeightB.value,
      cropCutWeightC: frmRef.current.cropCutWeightC.value,
      cropCutWeightD: frmRef.current.cropCutWeightD.value,
      remarkNote: frmRef.current.remarkNote.value,
      
       
    };

    if (props.update) {
      console.log("props",props)
      data["cropCutId"] = props.update.cropCutId;
      data["cropId"] = props.update.cropId;
      data["status"] = props.update.status;
      data["fileAttachment"] = props.update.fileAttachment;
      data["orgId"] = props.update.orgId;
      data["status"] = props.update.status;
      data["createdBy"] = props.update.createdBy;

      
      data["entryTime"] = props.update.entryTime;
      data["entryLatLong"] = props.update.entryLatLong;
       
       
    }

    console.log(data);

    postProductRequest(
      {
        url: "/api/cropCutDetail/",
        method: props.update ? "PUT" : "POST",
        body: [data],
      },
      (data) => { 
        console.log(data.length)
        console.log(data)
        if (data&&data.length>0)
        {
        toast.success(
          `Farmer crop cut ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }else
      {
        toast.error(
          `Error  in farmer crop cut ${props.update ? "update" : "Added"}.`
        );
      }

      }
    );
  };

  const { sendRequest: getProductsForUpdate } = useHttp();

  useEffect(() => {
    if (props.update) {
       console.log("update",props.update);

      frmRef.current.cropCutDate.value = moment(
        props.update.cropCutDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.farmerName.value = props.update.farmerName;
      frmRef.current.fieldExecutive.value=props.update.employeeName;
      frmRef.current.plotName.value=props.update.plotName;
      frmRef.current.cropVariety.value=props.update.cropName+'('+props.update.varietyName+')';
      
      frmRef.current.actualFieldSizeBeforeHarvest.value=props.update.actualFieldSizeBeforeHarvest;
      frmRef.current.cropCutWeightA.value=props.update.cropCutWeightA;
      frmRef.current.cropCutWeightB.value=props.update.cropCutWeightB;
      frmRef.current.cropCutWeightC.value=props.update.cropCutWeightC;
      frmRef.current.cropCutWeightD.value=props.update.cropCutWeightD
      frmRef.current.remarkNote.value=props.update.remarkNote
      setCropId(props.update.cropId)
        
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Farmer Input Template Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">

                    <label htmlFor={"date"}>{"Farmer Name"}</label>
 <input
                         
                        id={"farmerName"}
                        required
                        ref={(el) => (frmRef.current["farmerName"] = el)}
                        className="form-control"
                         
                      />
                    </div>
  
                    <div className="col-md-3">
                      <label htmlFor={"executive_name"}>
                        {"Field Executive"}
                      </label>
                      <input
                        id="templateName"
                        name="templateName"
                        ref={(el) => (frmRef.current["fieldExecutive"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>

                    <div className="col-md-3">
                    <label htmlFor={"date"}>{"Plot Name/Id"}</label>
                    <input
  id="plotName"
  name="plotName"
  ref={(el) => (frmRef.current["plotName"] = el)}
  className="form-control"
  readOnly
/>
                    </div>


                    <div className="col-md-3">
                      <label htmlFor={"crop"}>{"Crop(Variety)"}</label>
                      <input
                        id="templateName"
                        name="templateName"
                        ref={(el) => (frmRef.current["cropVariety"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>


                  </div>

                  <div className="row mb-2">



                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Crop Cut Date"}</label>
                      <input
                        type={"date"}
                        id={"cropCutDate"}
                        required
                        ref={(el) => (frmRef.current["cropCutDate"] = el)}
                        className="form-control"
                        min={props.update ?? currentDate}
                      />
                    </div>
                    <div className="col-md-6">
                      
                    <label htmlFor={"date"}>{"Actual Field Size Before Harvest(Ha)"}</label>

<input
  id="actualFieldSizeBeforeHarvest"
  name="actualFieldSizeBeforeHarvest"
  style={{"width":"40%"}}
  ref={(el) => (frmRef.current["actualFieldSizeBeforeHarvest"] = el)}
  className="form-control"
   
/>

                    </div>

                    <div className="col-md-3">
                    
                    </div>

                    <div className="col-md-3">
                      
                    </div>
                  </div>

                  <div className="row mb-2">



                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Crop Cut Weight A(kg)"}</label>
                      <input
                        type={"number"}
                        id={"cropCutWeightA"}
                        required
                        ref={(el) => (frmRef.current["cropCutWeightA"] = el)}
                        className="form-control"
                         
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Crop Cut Weight B(kg)"}</label>
                      <input
                        type={"number"}
                        id={"cropCutWeightB"}
                        required
                        ref={(el) => (frmRef.current["cropCutWeightB"] = el)}
                        className="form-control"
                         
                      />
                    </div>

                    

                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Crop Cut Weight C(kg)"}</label>
                      <input
                        type={"number"}
                        id={"cropCutWeightC"}
                        required
                        ref={(el) => (frmRef.current["cropCutWeightC"] = el)}
                        className="form-control"
                         
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Crop Cut Weight D(kg)"}</label>
                      <input
                        type={"number"}
                        id={"cropCutWeightD"}
                        required
                        ref={(el) => (frmRef.current["cropCutWeightD"] = el)}
                        className="form-control"
                         
                      />
                    </div>
                    </div>

                  <div className="row mb-2">
                   

                    <div className="col-md-3">
                      <label htmlFor={"description"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remarkNote"}
                        required
                        ref={(el) => (frmRef.current["remarkNote"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                     
                     </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

       
    </>
  );
};

export default FarmerCropCutForm;
